import { render, staticRenderFns } from "./StickersUpdate.vue?vue&type=template&id=018c538d&scoped=true&"
import script from "./StickersUpdate.vue?vue&type=script&lang=js&"
export * from "./StickersUpdate.vue?vue&type=script&lang=js&"
import style0 from "./StickersUpdate.vue?vue&type=style&index=0&id=018c538d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "018c538d",
  null
  
)

export default component.exports